var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgParentContactNobg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.11536 0.000103448C3.04166 0.000103448 0.543457 2.49831 0.543457 5.57201C0.543457 7.08399 1.16345 8.53846 2.25427 9.58745L1.28897 12.5147C1.26802 12.5801 1.28897 12.6507 1.34126 12.6952C1.37523 12.7213 1.41449 12.7371 1.45374 12.7371C1.47989 12.7371 1.50603 12.7292 1.52962 12.7188L4.91462 11.0132C5.30437 11.0996 5.70986 11.144 6.11792 11.144C9.18901 11.144 11.6898 8.64322 11.6898 5.57213C11.6873 2.4982 9.18639 0 6.1153 0L6.11536 0.000103448Z",
    fill: "#DBDFF5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParentContactNobg);
export default __webpack_public_path__ + "static/media/parentContactNobg.c127c3f8b34d446325fc5e5a796a5891.svg";
export { ForwardRef as ReactComponent };